import * as React from "react";
import { Close } from "@mui/icons-material";
import { Box, IconButton, Popover, Typography } from "@mui/material";

export default function CustomPopper({
  icon,
  buttonStyle,
  containerStyle,
  placement = "right",
  closeOnClick = false,
  children,
  popperStyle,
}: {
  icon?: JSX.Element;
  closeOnClick?: boolean;
  placement?: "right" | "center" | "left";
  buttonStyle?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
  popperStyle?: React.CSSProperties;
  onClose?: () => void;
  children?: JSX.Element;
}) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const onMouseClick = () => {
    if (closeOnClick) {
      handleClose();
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <Box>
      <IconButton
        sx={{
          backgroundColor: "#E6EAEE",
          height: 45,
          width: 45,
          borderRadius: "8px",
          ...buttonStyle,
        }}
        onClick={handleClick}
      >
        {icon}
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: placement,
        }}
        sx={{ ...popperStyle }}
      >
        <Box
          sx={{ borderRadius: 2, p: 3, ...containerStyle }}
          onClick={onMouseClick}
        >
          {children}
        </Box>
      </Popover>
    </Box>
  );
}
